export const appShellTheme = {
  baseStyle: {
    container: {
      bg: 'transparent',
    },
    inner: {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      bg: 'transparent',
    },
    main: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      bg: 'transparent',
    },
  },
  variants: {
    fullscreen: {
      container: {
        position: 'absolute',
        inset: 0,
        height: '100dvh',
        overflow: 'hidden',
        bg: 'transparent',
        // Sits above ShellAtmosphere (z-index 0). This is a stacking
        // context, so the mobile nav overlay must stay in-tree.
        zIndex: 1,
      },
    },
  },
  defaultProps: {
    variant: 'fullscreen',
  },
};
